// Components==============
import { motion } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { GlobalContext } from 'utilities/GlobalContext';
import { useKeyboard } from 'utilities/useKeyboard';
import StatusBox, { BoxTypes } from '../StatusBox/StatusBox';
import './InputField.module.scss';
// =========================

type Props = {
    boxState: BoxTypes;
    setBoxState: React.Dispatch<React.SetStateAction<BoxTypes>>;
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    text?: string;
    readOnly: boolean;
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    reference?: React.RefObject<HTMLInputElement>;
    active?: boolean;
    handleInputClick?: (
        e?: React.MouseEvent<HTMLInputElement, MouseEvent>
    ) => void;
};

export default function InputField({
    boxState,
    setBoxState,
    readOnly,
    value,
    setValue,
    handleSubmit,
    text,
    reference,
    active,
    handleInputClick,
}: Props) {
    const { setKeyboardIsOpen } = useContext(GlobalContext);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setValue(e.target.value);
    }

    const background = text
        ? '#FFFFFF'
        : boxState !== 'correct' && boxState !== 'failed'
        ? '#BDCCD4'
        : '#FFFFFF';

    const conditionalActive = typeof active === 'undefined' ? true : active;

    useKeyboard({
        setValue,
        condition: !readOnly && conditionalActive,
        handleEnter: () => handleSubmit(),
    });

    useEffect(() => {
        if (boxState === 'correct' || boxState === 'failed') return;

        if (value === '') {
            setBoxState('initial');
        } else {
            setBoxState('submit');
        }
    }, [value]);

    useEffect(() => {
        if (boxState === 'failed' || boxState === 'correct')
            setKeyboardIsOpen(false);
    }, [boxState]);

    return (
        <motion.form
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            styleName="form"
            onSubmit={handleSubmit}
            style={{
                background,
                padding: text && 0,
            }}
            autoComplete="off"
        >
            <input
                ref={reference}
                type="text"
                name="word"
                value={text || value}
                onChange={handleChange}
                readOnly={readOnly}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                onClick={handleInputClick}
            />
            {!text && (
                <StatusBox
                    boxState={boxState}
                    background={background}
                    inputField
                />
            )}
        </motion.form>
    );
}
